import styled from 'styled-components';
import { PhotographyWrapper } from '../photography/PhotographyStyles';

export const ContactsWrapper = styled(PhotographyWrapper)`
  position: relative; z-index: 2;
  .contact-layout { display: grid; grid-template-columns: 1fr 1.08fr; gap: 80px; align-items: start; }
  .contact-intro { padding-top: 22px; }
  .contact-direct { display: grid; gap: 26px; margin: 36px 0; }
  .contact-direct span { display: block; font: 600 15px/1.5 'Nunito Sans', sans-serif; color: #52617e; margin-bottom: 6px; }
  .contact-direct a { color: #1b264f; font: 600 clamp(20px, 2vw, 25px)/1.5 Poppins, sans-serif; text-decoration: none; overflow-wrap: anywhere; }
  .contact-direct a:hover { color: #2c5bff; }
  .contact-social { border-top: 1px solid #e4e8ef; padding-top: 24px; }
  .contact-social p { font: 600 15px/1.5 'Nunito Sans', sans-serif; color: #52617e; margin: 0 0 12px; }
  .contact-social > div { display: flex; flex-wrap: wrap; gap: 14px 24px; }
  .contact-social a { color: #2c5bff; font: 600 16px/1.5 'Nunito Sans', sans-serif; text-decoration: none; }
  .contact-form-panel { border: 1px solid #e0e6f0; border-radius: 16px; padding: 32px; box-shadow: 0 12px 40px #1b264f06; background: white; }
  .contact-form-panel h2 { font: 600 26px/1.3 Poppins, sans-serif; letter-spacing: -.025em; margin: 0 0 8px; color: #1b264f; text-transform: none; }
  .contact-form-intro { font: 400 17px/1.6 'Nunito Sans', sans-serif; color: #52617e; margin: 0 0 24px; }
  .contact-form-panel label { display: block; font: 600 15px/1.5 'Nunito Sans', sans-serif; color: #1b264f; margin: 0 0 18px; }
  .contact-name-row { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 18px; }
  .contact-form-panel input, .contact-form-panel textarea { display: block; width: 100%; box-sizing: border-box; background: #fcfdff; border: 1px solid #cbd5e5; border-radius: 8px; color: #1b264f; font: 400 17px/1.5 'Nunito Sans', sans-serif; padding: 12px 14px; margin-top: 7px; }
  .contact-form-panel textarea { resize: vertical; min-height: 110px; }
  .contact-form-panel textarea::placeholder { color: #697892; opacity: 1; }
  .contact-form-panel input:focus, .contact-form-panel textarea:focus { border-color: #2c5bff; outline: 2px solid #2c5bff30; outline-offset: 2px; }
  .contact-optional { color: #68758d; font-weight: 400; }
  .contact-required { font: 400 14px/1.5 'Nunito Sans', sans-serif; color: #68758d; margin: -4px 0 16px; }
  .photo-primary:disabled { opacity: .65; cursor: wait; }
  .contact-success, .contact-error { font: 600 16px/1.6 'Nunito Sans', sans-serif; padding: 14px; border-radius: 8px; margin: 18px 0 0; }
  .contact-success { background: #eff8f4; color: #236045; }
  .contact-error { background: #fff3f2; color: #9e302c; }
  .contact-help-band { background: #f6f8fc; }
  .contact-help { display: grid; grid-template-columns: .85fr 1.8fr; gap: 56px; padding-top: 48px; padding-bottom: 48px; }
  .contact-help .photo-title { font-size: clamp(26px,2.5vw,34px); margin-bottom: 0; }
  .contact-shortcuts { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 28px; }
  .contact-shortcuts h3 { font-size: 18px; }
  .contact-book { border: 0; padding: 0; background: transparent; cursor: pointer; text-align: left; }
  .contact-shortcuts p { font: 400 16px/1.65 'Nunito Sans', sans-serif; color: #52617e; margin: 0 0 16px; }
  .contact-gallery-heading { display: flex; justify-content: space-between; align-items: end; gap: 28px; margin-bottom: 28px; }
  .contact-gallery-heading .photo-title { margin-bottom: 0; }
  .contact-gallery-heading > a { flex-shrink: 0; margin-bottom: 4px; }
  .contact-gallery { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 20px; }
  .contact-gallery img { display: block; width: 100%; height: 230px; border-radius: 12px; object-fit: cover; }
  @media (max-width: 1100px) { .contact-layout { gap: 40px; } .contact-help { display: block; } .contact-shortcuts { margin-top: 28px; } }
  @media (max-width: 767px) {
    .contact-layout { grid-template-columns: 1fr; gap: 32px; }
    .contact-intro { padding-top: 0; }
    .contact-direct { margin: 28px 0; gap: 20px; }
    .contact-form-panel { padding: 24px 20px; }
    .contact-form-panel h2 { font-size: 24px; }
    .contact-name-row { gap: 12px; }
    .contact-form-panel .photo-primary { width: 100%; }
    .contact-shortcuts { grid-template-columns: 1fr; gap: 26px; }
    .contact-shortcuts > div { border-top: 1px solid #dce3ef; padding-top: 22px; }
    .contact-gallery-heading { display: block; }
    .contact-gallery-heading > a { display: inline-block; margin: 20px 0 0; }
    .contact-gallery { grid-template-columns: repeat(2,minmax(0,1fr)); gap: 12px; }
    .contact-gallery img { height: 160px; }
    .contact-gallery img:last-child { grid-column: 1 / -1; height: 210px; }
  }
`;
